import { FormBehavior } from './index';

export const defaultBehavior: FormBehavior = {
  renderHeader: () => null,
  
  getTemplate: (templateData, isAltView) => {
    return templateData.body;
  },
  
  supportsAltTemplate: false,
  
  customActions: [],
  
  customLogic: {
    onBeforeCreate: (data) => data,
    onBeforeUpdate: (data) => data,
    onAfterLoad: (data) => data
  }
};